import { FormField, Input } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

import { type BankInfosErrors, type SupplierBankInfos } from '../../../models';

type Props = {
  className?: string;
  isOptional?: boolean;
  accountCode: SupplierBankInfos['accountCode'];
  error?: BankInfosErrors['accountCode'];
  onChange(accountNumber: SupplierBankInfos['accountCode']): void;
};

export const AccountCodeFormField = ({
  className,
  isOptional,
  accountCode,
  error,
  onChange,
}: Props) => {
  const { t } = useTranslation('global');

  const getMessageFromError = (
    rawError: BankInfosErrors['accountCode'],
  ): string => {
    switch (rawError) {
      case 'invalid': {
        return t('submitMyInvoice.fields.accountCode.error');
      }
      default:
        return t('misc.requiredField');
    }
  };

  return (
    <FormField
      className={className}
      label={t('submitMyInvoice.fields.accountCode.label')}
      alertMessage={error ? getMessageFromError(error) : undefined}
      hint={isOptional ? t('misc.optional') : undefined}
    >
      <Input
        name="accountCode"
        value={accountCode ?? ''}
        placeholder={t('submitMyInvoice.fields.accountCode.placeholder')}
        pattern="\d{0,26}"
        onChange={(event) => {
          if (event.target.checkValidity()) {
            onChange(event.target.value);
          }
        }}
        data-mask
      />
    </FormField>
  );
};
